/**
 * Status labels rendered in the Leg Time Stamp table.
 * The label is also the `status` value posted to `leg/UpdateLegTimeStamp`,
 * so these strings must stay in sync with the backend `LegStatus` constants.
 */
export enum LegTimeStampStatusEnum {
  // Ground
  EnRoute = 'Enroute',
  OnScene = 'On-Scene',
  PickedUp = 'Picked up',
  DroppedOff = 'Dropped Off',
  DriverDone = 'Driver Done',
  // Air
  OnStandby = 'On Standby',
  Repositioning = 'Repositioning',
  InPosition = 'In Position',
  WheelsUp = 'Wheels Up',
  Landed = 'Landed',
  InboundWheelsUp = 'Inbound Wheels Up',
  InboundLanded = 'Inbound Landed',
  // Both
  JobDone = 'Job Done',
}
